import React from 'react';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const atcLogo = '//www.autotrader.com/cm-api/content/static/img/icon/logos/atc-logo-flat.svg';
const atcBlueLogo = '//www.autotrader.com/cm-api/content/static/img/icon/logos/atc-logo-blue.svg';
const title = 'Autotrader Used Cars For Sale - New Cars For Sale - SUVs And Trucks For Sale';
const alt = 'Autotrader Logo';
const brand = function (isTransparent) {
  if (isTransparent === void 0) {
    isTransparent = false;
  }
  const logoSrc = isTransparent ? atcLogo : atcBlueLogo;
  return /*#__PURE__*/_jsxs("a", {
    href: "/",
    "aria-label": "Find Cars for Sale at Autotrader",
    children: [/*#__PURE__*/_jsx("img", {
      className: "display-inline-block display-lg-none",
      src: logoSrc,
      width: 110,
      height: 27,
      title: title,
      alt: alt,
      loading: "eager"
    }), /*#__PURE__*/_jsx("img", {
      className: "display-none display-lg-block",
      src: logoSrc,
      width: 139,
      height: 38,
      title: title,
      alt: alt,
      loading: "eager"
    })]
  });
};

// Reusable sponsored content images
const sponsoredImages = {
  kbbLogo: {
    alt: 'KBB',
    height: '32px',
    loading: 'lazy',
    lazyload: true,
    src: 'https://www.autotrader.com/content/dam/autotrader/additionalresources/kbb_logo.svg',
    width: '22px'
  },
  shieldCheck: {
    alt: 'KBB Insurance market place',
    height: '32px',
    loading: 'lazy',
    lazyload: true,
    src: 'https://www.autotrader.com/content/dam/autotrader/additionalresources/shield_check.svg',
    width: '32px'
  },
  autoCheck: {
    alt: 'AutoCheck',
    height: '40px',
    loading: 'lazy',
    lazyload: true,
    src: 'https://www.autotrader.com/content/static/img/vhr/experian/autocheck-by-kbb-stacked.svg',
    width: '53px'
  },
  tagOrange: {
    alt: 'List your car for sale on Autotrader and KBB.com',
    height: '32px',
    loading: 'lazy',
    lazyload: true,
    src: 'https://www.autotrader.com/content/dam/autotrader/additionalresources/tag-orange.svg',
    width: '32px'
  }
};

// Reusable sponsored content factories
const createSponsoredItem = function (eventkey, image, link, additionalProps) {
  if (additionalProps === void 0) {
    additionalProps = {};
  }
  return {
    eventkey,
    image,
    link,
    ...additionalProps
  };
};
const sponsoredLinks = {
  kbbInsurance: {
    href: 'https://www.kbb.com/camp/root-insurance',
    label: 'See if you can save on car insurance on KBB.com'
  },
  autoCheckVhr: {
    href: '/camp/vehicle-history-report-vin-check',
    label: 'Run a free AutoCheck Vehicle History Report with Experian'
  }
};
const carResearchMenuLinks = [{
  text: 'Helpful Links',
  items: [{
    eventkey: '2',
    href: '/car-deals/best-new-car-deals-281474979990473',
    text: 'Best Car Deals',
    onEventKey: 'lnkBestCarDl',
    destination: 'Car Deals'
  }, {
    eventkey: '3',
    href: '/car-deals/best-truck-deals-281474979990475',
    text: 'Best Truck Deals',
    onEventKey: 'lnkTruckDl',
    destination: 'Truck Deals'
  }, {
    eventkey: '4',
    href: '/car-deals/best-suv-deals-281474979990474',
    text: 'Best SUV Deals',
    onEventKey: 'lnkSuvDl',
    destination: 'SUV Deals'
  }, {
    eventkey: '5',
    href: '/how-to-buy-cars-online',
    text: 'Buy Cars Online',
    onEventKey: 'lnkBcoHdr',
    destination: 'Buy Cars Online'
  }]
}, {
  text: 'Car Research & News',
  items: [{
    eventkey: '1',
    href: '/research',
    text: 'Research & Information',
    onEventKey: 'lnkCr',
    destination: 'Research Infomation'
  }, {
    eventkey: '2',
    href: '/research/new-model',
    text: 'New & Future Models',
    onEventKey: 'lnkNwFutMdl',
    destination: 'New Future Articles'
  }, {
    eventkey: '3',
    href: '/comparisons/trim-comparisons',
    text: 'Trim Comparisons',
    onEventKey: 'lnkTrimCprs',
    destination: 'Trim Comparisons'
  }]
}, {
  text: 'Car Buying Tools',
  items: [{
    eventkey: '1',
    href: '/car-shopping',
    text: 'Buying and Selling Tips',
    onEventKey: 'lnkBuyCar',
    destination: 'Buying and Selling Tips'
  }, {
    eventkey: '2',
    href: '/car-payment-calculator',
    text: 'Car Payment Calculator',
    onEventKey: 'lnkMnthPmtCalc',
    destination: 'Car Payment Calculator'
  }, {
    eventkey: '3',
    href: '/car-affordability-calculator',
    text: 'Affordability Calculator',
    onEventKey: 'lnkAfdCalc',
    destination: 'Affordability Calculator'
  }, {
    eventkey: '4',
    href: '/car-lease-calculator',
    text: 'Car Lease Calculator',
    onEventKey: 'lnkLeaseCalc',
    destination: 'Car Lease Calculator'
  }]
}];

// Common base nav items shared between traditional and consolidated navigation
const baseNavItems = [{
  eventkey: 1,
  href: '/',
  text: 'Home',
  className: 'display-md-none',
  onEventKey: 'home',
  linkContext: 'HeaderNav',
  glyph: 'home'
}, {
  eventkey: 2,
  href: '/cars-for-sale',
  text: 'Used Cars',
  onEventKey: 'lnkFycUsed',
  linkContext: 'HeaderNav',
  glyph: 'odometer'
}, {
  eventkey: 3,
  href: '/new-cars',
  text: 'New Cars',
  onEventKey: 'lnkFycNew',
  linkContext: 'HeaderNav',
  glyphOverride: '//www.autotrader.com/content/dam/autotrader/homepage/nav/car-front.svg' // use IRIS `car-front` glyph when available
}, {
  eventkey: 4,
  href: '/cars-for-sale/by-owner',
  text: 'Private Seller Cars',
  onEventKey: 'privateSeller',
  linkContext: 'HeaderNav',
  glyph: 'hand-key'
}];
const navItems = [...baseNavItems, {
  eventkey: 5,
  href: '/sell-my-car',
  text: 'Sell My Car',
  onEventKey: 'lnkSyc',
  linkContext: 'HeaderNav',
  glyph: 'car-tag'
}, {
  eventkey: 6,
  href: '/instant-cash-offer/?LNX=TIMATCHPNAV',
  text: 'Instant Cash Offer',
  onEventKey: 'lnkTim',
  linkContext: 'HeaderNav',
  glyph: 'money'
}, {
  eventkey: 7,
  text: 'Car Research & Tools',
  glyph: 'academic-cap',
  items: carResearchMenuLinks
}, {
  eventkey: 8,
  href: '/car-dealers',
  text: 'Find Local Dealers',
  onEventKey: 'lnkFyd',
  linkContext: 'HeaderNav',
  glyph: 'dealership'
}];
const getConsolidatedNavItems = function (showAiModeLink, aiModeLinkDestination) {
  if (showAiModeLink === void 0) {
    showAiModeLink = false;
  }
  if (aiModeLinkDestination === void 0) {
    aiModeLinkDestination = 'ai-mode';
  }
  const items = [...baseNavItems, {
    eventkey: 5,
    text: 'Sell or Trade-In',
    glyph: 'car-tag',
    items: [],
    // items array will trigger this menu item to be a popover drop down menu
    popoverWidth: 364,
    showSponsoredContentSeperator: false,
    linkContext: 'HeaderNav',
    onEventKey: 'sellOrTradeInDropdown',
    sponsoredContentLayout: 'vertical' // 'vertical' or 'horizontal'
  }, {
    eventkey: 6,
    text: 'Research & Tools',
    glyph: 'academic-cap',
    sponsoredContentLayout: 'horizontal',
    // 'vertical' or 'horizontal'
    items: [{
      text: 'Helpful Links',
      items: [{
        eventkey: '1',
        href: '/car-dealers',
        text: 'Find Local Dealers',
        onEventKey: 'lnkFld',
        destination: 'Find Local Dealers'
      }, ...carResearchMenuLinks[0].items]
    }, ...carResearchMenuLinks.slice(1)]
  }];
  if (showAiModeLink) {
    items.push({
      eventkey: 7,
      href: `https://www.autotrader.com/${aiModeLinkDestination}`,
      text: 'AI Mode',
      onEventKey: 'lnkAiMode',
      linkContext: 'HeaderNav',
      glyph: 'sparkles',
      isBeta: true,
      isOffsite: true,
      target: '_blank',
      rel: 'noopener noreferrer'
    });
  }
  return items;
};
const sponsoredContent = [createSponsoredItem(7, sponsoredImages.shieldCheck, sponsoredLinks.kbbInsurance, {
  onEventKey: 'lnkKbbIM'
}), createSponsoredItem(7, sponsoredImages.kbbLogo, {
  href: '/instant-cash-offer/?LNX=TIMATCHPNAVCNR',
  label: 'Get a Kelley Blue Book® Instant Cash Offer'
}, {
  onEventKey: 'lnkKbbTim'
}), createSponsoredItem(7, sponsoredImages.autoCheck, sponsoredLinks.autoCheckVhr, {
  name: 'AutoCheck',
  onEventKey: 'lnkAutoCheck',
  enableTriggerSponsorImpression: true
})];
const consolidatedSponsoredContent = [createSponsoredItem(5, sponsoredImages.tagOrange, {
  href: '/sell-my-car',
  label: /*#__PURE__*/_jsxs(_Fragment, {
    children: ["List your car for sale on", ' ', /*#__PURE__*/_jsx("strong", {
      children: "Autotrader and KBB.com"
    })]
  })
}, {
  onEventKey: 'lnkSellMyCar',
  openToNewWindow: false
}), createSponsoredItem(5, sponsoredImages.kbbLogo, {
  href: '/instant-cash-offer/?LNX=TIMATCHPNAV',
  label: /*#__PURE__*/_jsxs(_Fragment, {
    children: ["Get a Kelley Blue Book\xAE", ' ', /*#__PURE__*/_jsx("strong", {
      children: "Instant Cash Offer"
    }), ' ', "and walk away with a check or trade-in credit"]
  })
}, {
  onEventKey: 'lnkIco',
  openToNewWindow: false
}), createSponsoredItem(6, sponsoredImages.shieldCheck, sponsoredLinks.kbbInsurance, {
  onEventKey: 'lnkKbbIM'
}), createSponsoredItem(6, sponsoredImages.autoCheck, sponsoredLinks.autoCheckVhr, {
  name: 'AutoCheck',
  onEventKey: 'lnkAutoCheck',
  enableTriggerSponsorImpression: true
})];
export default {
  brand,
  navItems,
  sponsoredContent,
  getConsolidatedNavItems,
  consolidatedSponsoredContent
};